// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

// This file is generated by /js/scripts/update-version.ts
// Do not modify file content manually.

export const version = '1.24.3';
